module.exports = __webpack_public_path__ + "static/media/Gadget.204580c9.svg";